<template>
    <div
        class="embed-node"
        :class="{'left': align == 'left', 'right': align == 'right'}"
        :style="{
            width: width,
            height: height,
            float: align
        }"
    >
        <iframe
            :src="src"
            :alt="alt"
            :height="height"
            tabindex="-1"
            @keydown.delete="deleteNode"
            @keydown.escape="deleteNode"
            allowfullscreen
        />

        <span class="node-actions">
            <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                <font-awesome-icon :icon="['far', 'edit']" />
            </b-btn>
            <b-btn size="sm" variant="danger" @click.prevent="deleteNode">
                <font-awesome-icon :icon="['fad', 'trash']" />
            </b-btn>
        </span>

        <EmbedExtensionModal
            v-model="showImageModal"
            :view="view"
            :embed="embed"
            @save="save"
            @hide="showImageModal = false"
        />
    </div>
</template>

<script>
import EmbedExtensionModal from "@/components/tiptap/extensions/EmbedExtensionModal";
export default {
    name: "EmbedExtensionView",
    components: {EmbedExtensionModal},
    props: ['node', 'updateAttrs', 'view', 'getPos'],
    data:() => ({
        showImageModal: false,
    }),
    computed: {
        src: {
            get () {
                return this.node.attrs.src
            },
            set (src) {
                this.updateAttrs({
                    src
                })
            }
        },
        align: {
            get () {
                return this.node.attrs.align
            },
            set (align) {
                this.updateAttrs({
                    align
                })
            }
        },
        alt: {
            get () {
                return this.node.attrs.alt
            },
            set (alt) {
                this.updateAttrs({
                    alt
                })
            }
        },
        caption: {
            get () {
                if (this.node.attrs.caption) {
                    return this.node.attrs.caption
                } else {
                    return null
                }
            },
            set (caption) {
                this.updateAttrs({
                    caption
                })
            }
        },
        credit: {
            get () {
                if (this.node.attrs.credit) {
                    return this.node.attrs.credit
                } else {
                    return null
                }
            },
            set (credit) {
                this.updateAttrs({
                    credit
                })
            }
        },
        width: {
            get () {
                if (this.node.attrs.width) {
                    return this.node.attrs.width
                } else {
                    return null
                }
            },
            set (width) {
                this.updateAttrs({
                    width
                })
            }
        },
        height: {
            get () {
                if (this.node.attrs.height) {
                    return this.node.attrs.height
                } else {
                    return null
                }
            },
            set (height) {
                this.updateAttrs({
                    height
                })
            }
        },
        style: {
            get () {
                if (this.node.attrs.style) {
                    return this.node.attrs.style
                } else {
                    return null
                }
            },
            set (style) {
                this.updateAttrs({
                    style
                })
            }
        },
        embed () {
            let embed = {}

            if (this.src) {
                embed.src = this.src
            }

            if (this.width) {
                embed.width = this.width
            }

            if (this.height) {
                embed.height = this.height
            }

            if (this.align) {
                embed.align = this.align
            }

            if (this.alt) {
                embed.alt = this.alt
            }

            if (this.caption) {
                embed.caption = this.caption
            }

            if (this.credit) {
                embed.credit = this.credit
            }

            return embed
        }
    },

    methods: {
        edit() {
            this.showImageModal = true;
        },
        save ({src, width, height, align, caption, alt, credit}) {

            if (width)
                width = width + '%'
            if (height)
                height = height + 'px'

            if (src)
                this.updateAttrs({src});

            this.updateAttrs({width});

            this.updateAttrs({height});

            this.updateAttrs({align});

            this.updateAttrs({caption});

            this.updateAttrs({alt});

            this.updateAttrs({credit});

            this.showImageModal = false;
        },
        deleteNode () {
            let tr = null
            let pos = this.getPos()

            if (this.view) {
                tr = this.view.state.tr
            }

            tr.delete(pos, pos + this.node.nodeSize)

            this.view.dispatch(tr)

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.embed-node {
    display: inline-flex;
    position: relative;
    min-height: 50px;

    iframe {
        width: 100%;
        transition: ease .25s;
        margin-bottom: 1rem;
    }

    .caption {
        display: none;
    }

    .merlin-id {
        position: absolute;
        font-size: 80%;
        bottom: 1rem;
        left: 5px;
        background: white;
    }

    .node-actions {
        position: absolute;
        display: none;
        top: 10px;
        left: 10px;
        * + * {
            margin-left: .25rem;
        }
    }

    &.left {
        float: left;
        justify-content: flex-start;
        margin-right: 10px;
        .node-actions {
            left: 10px;
            right: auto;
        }
    }

    &.right {
        float: right;
        justify-content: flex-end;
        margin-left: 10px;
        .node-actions {
            left: auto;
            right: 10px;
        }
    }

    &:hover {
        img {
            filter: brightness(75%);
        }
        .node-actions {
            display: block;
        }
    }
}

</style>